const uuid = require('uuid/v4');

const notificationUrlV4 = process.env.host + '/' + process.env.version_v4 + '/' + process.env.prefix_notification

const FCDS_PAYLOAD_MEMBERSHIP_REGISTRATION = {
  first_name: 'FIRST_NAME',
  last_name: 'LAST_NAME',
  app_domain: `${notificationUrlV4}/redirect`,
  web_domain: `${notificationUrlV4}/redirect`,
  token: uuid(),
}

const FCDS_PAYLOAD_MEMBERSHIP_REGISTRATION_NOTIFICATION = {
  first_name: 'FIRST_NAME',
  last_name: 'LAST_NAME',
}

const FCDS_PAYLOAD_RESET_PASSWORD = {
  first_name: 'FIRST_NAME',
  last_name: 'LAST_NAME',
  web_domain: `${notificationUrlV4}/redirect`,
  token: uuid(),
}

const FCDS_PAYLOAD_RESET_PASSWORD_SUCCESS = {
  first_name: 'FIRST_NAME',
  last_name: 'LAST_NAME',
}

const FCDS_ORDER_IN_OVEN_PAYLOAD = {
  name: 'NAME',
  order_tracker_url: `${notificationUrlV4}/redirect/${uuid()}`
}

const FCDS_ORDER_ON_DELIVERY_PAYLOAD = {
  name: 'NAME',
  order_tracker_url: `${notificationUrlV4}/redirect/${uuid()}`
}

const FCDS_ORDER_READY_PAYLOAD = {
  name: 'NAME',
  order_tracker_url: `${notificationUrlV4}/redirect/${uuid()}`
}

const FCDS_ORDER_CONFIRMATION_PAYLOAD = {
  name: 'NAME',
  order_tracker_url: `${notificationUrlV4}/redirect/${uuid()}`
}

export const getPayload = emailType => {
  switch (emailType) {
    case 'confirmation':
    case 'light_confirmation':
      return FCDS_PAYLOAD_MEMBERSHIP_REGISTRATION
    case 'notify':
    case 'light_notify':
      return FCDS_PAYLOAD_MEMBERSHIP_REGISTRATION_NOTIFICATION
    case 'reset_password':
      return FCDS_PAYLOAD_RESET_PASSWORD
    case 'reset_password_success':
      return FCDS_PAYLOAD_RESET_PASSWORD_SUCCESS
    case 'order_confirmation_carryout':
    case 'order_confirmation_delivery':
    case 'order_confirmation':
      return FCDS_ORDER_CONFIRMATION_PAYLOAD
    case 'order_ready':
      return FCDS_ORDER_READY_PAYLOAD
    case 'order_delivering':
      return FCDS_ORDER_ON_DELIVERY_PAYLOAD
    case 'order_cooking':
      return FCDS_ORDER_IN_OVEN_PAYLOAD
    case 'order_process':
      return FCDS_ORDER_PAYLOAD
    default:
      return {}
  }
}



// WEBPACK FOOTER //
// ./src/views/admin/email-template/payloads/index.js